<template>
<div>
    <x-header @on-click-back="xback" :left-options="{preventGoBack:true}">当天消费查询</x-header>   
      <div class="row">
          <div class="input-group col-md-11">
            <span class="input-group-addon" >身份证号码</span>
            <input type="text" class="form-control" v-model="xtype" >
            <span class="input-group-btn">
              <button class="btn btn-default" @click.stop="initData" type="button">查询</button>
            </span>
          </div>
      </div>
<divider v-if="dataList.length>0">{{dataList[0].empName}}  {{dataList[0].empId}}</divider>

 <div style="padding:0 15px;">
      <x-table :cell-bordered="false" :content-bordered="false" style="background-color:#fff;">
        <thead>
          <tr style="background-color: #F7F7F7">
            <th>时间</th>
            <th>金额</th>
            <th>余额</th>
            <th>项目</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item,i) in dataList" :key="i">
            <td>{{item.ctime.substring(0,8)}}</td>
            <td>{{item.expand}}</td>
            <td>{{item.balance}}</td>
            <td>{{item.declareName}}</td>
          </tr>
        </tbody>
      </x-table>
    </div>
</div>
</template>


<script>
import { XHeader, Divider,Grid, GridItem, GroupTitle,ButtonTab,ButtonTabItem,Group, Cell, Marquee, MarqueeItem,XTable } from 'vux'

export default {
  data () {
    return {
      asyncCount: 5,
      xtype:"",
      dataList:[],
      tout: null,
      epd:0,
      crs:0
    }
  },
  methods:{
    xback(){
      this.$router.push("dc")
    },
    dtoday(){
      if (this.xtype != 1){
        this.xtype=1
        this.initData()
      }
    },
    dweek(){
      if (this.xtype != 2){
        this.xtype=2
        this.initData()
      }
    },
    dmonth(){
      if (this.xtype != 3){
        this.xtype=3
        this.initData()
      }
    },
    initData(){
      if (this.tout) clearTimeout(this.tout)
      if (this.$trim(this.xtype)=="") return
      this.$getData(this.$baseUrl+"DinnerRecord/GetCons?idNo=" + this.xtype, data=>{
        if (data.rs==1){
          this.dataList = data.list
          console.log(this.dataList)
        }
        
      this.tout = setTimeout(() => {
        this.initData()
      }, 5000)
      })
    }
  },
  mounted () {
    setTimeout(() => {
      this.asyncCount = 5
    }, 1000)
  },
  components: {
    Divider,
    XHeader,
    Grid, 
    GridItem, 
    GroupTitle,
    ButtonTab,
    ButtonTabItem,Group, Cell, Marquee, MarqueeItem,XTable
  }
}
</script>
<style scoped>
document body {
  background-color: #fff import;
}
.grid-center {
  display: block;
  text-align: center;
  color: #666;
}
.weui-grids {
  background-color: #fff;
}
.align-middle {
  text-align: center;
}
</style>
